import { defineCatalogue } from '../../../i18n';

export const accountsCatalogue = defineCatalogue(
  {
    title: 'Contas monitoradas',
    subtitle: 'Contas acompanhadas pela campanha e o custo do seu monitoramento.',
    'nav.overview': 'Visão geral',
    'nav.account': 'Conta',
    'search.placeholder': 'Buscar conta monitorada',
    'search.label': 'Buscar conta monitorada',
    'filter.platform': 'Plataforma',
    'filter.allPlatforms': 'Todas as plataformas',
    'add.account': 'Adicionar conta',
    'hint.profiles.label': 'perfis acompanhados',
    'hint.profiles.what':
      'Acompanhe perfis públicos: candidatos, figuras públicas, veículos e organizações.',
    'hint.profiles.alignment':
      'O alinhamento (própria, aliada, oposição…) é uma classificação da campanha sobre esses perfis.',

    'platform.instagram': 'Instagram',
    'platform.tiktok': 'TikTok',

    'band.ally': 'Aliado',
    'band.neutral': 'Neutro',
    'band.adversary': 'Adversário',
    'band.campaign': 'Próprias',
    'alignment.campaign': 'Própria',
    'alignment.change': 'Mudar o alinhamento',
    'tag.category': '{category}:',
    'card.menu': 'Ações da conta',
    'card.open': 'Ver',
    'card.edit': 'Editar rastreamento',
    'card.rename': 'Renomear',
    'card.remove': 'Parar de monitorar',
    'card.customProfile': 'Personalizado',
    'card.customised': 'Perfil de coleta personalizado para esta conta',
    'card.related': 'Publicações relacionadas à campanha nos últimos 7 dias',
    'card.reach': 'Alcance das publicações relacionadas nos últimos 7 dias',
    'card.lastCollected': 'Última publicação coletada {when}',
    'card.private': 'Conta privada',
    'card.verified': 'Conta verificada',
    'card.followers': 'Seguidores',
    'profile.followers': 'seguidores',
    'profile.following': 'seguindo',
    'profile.posts': 'publicações',
    'status.paused': 'pausado',
    'status.paused.hint': 'Monitoramento pausado: nenhuma mídia está sendo coletada',
    'status.waiting': 'aguardando',
    'status.waiting.hint': 'Aguardando a primeira coleta',
    'empty.title': 'Nenhuma conta monitorada',
    'empty.description': 'Nenhuma conta encontrada com os filtros selecionados.',
    'error.title': 'Erro ao carregar contas',
    'error.description': 'Não foi possível carregar a lista de contas monitoradas.',
    loading: 'Carregando contas...',
    unknownHandle: 'Conta sem usuário',
    defaultProfile: 'Padrão da campanha',

    'detail.title': 'Detalhes da conta',
    'detail.back': 'Voltar para Contas monitoradas',
    'detail.edit': 'Editar configuração',
    'detail.trackingSummary': 'Resumo do monitoramento',
    'detail.mediaEnabled': 'Mídias ativas',
    'detail.comments': 'Comentários',
    'detail.commentsCap': 'Limite de comentários',
    'detail.likers': 'Curtidas',
    'detail.audioFanout': 'Fan-out de áudio',
    'detail.audioPageLimit': 'Limite de páginas de áudio',
    'detail.enabled': 'Ativo',
    'detail.disabled': 'Desativado',

    'analysisScope.label': 'Escopo de análise',
    'analysisScope.hint':
      'Quais publicações desta conta recebem métricas, comentários, curtidas e análise de comentários.',
    'analysisScope.inherit': 'Herdar do alinhamento ({effective})',
    'analysisScope.all': 'Todas as publicações',
    'analysisScope.related': 'Só as relacionadas',
    'analysisScope.effective.ALL': 'todas as publicações',
    'analysisScope.effective.RELATED': 'só as relacionadas',

    'candidate.label': 'Candidato responsável',
    'candidate.none': 'Nenhum / não se aplica',
    'candidate.clear': 'Limpar',
    'candidate.fromAlliances': 'Adversários da campanha',
    'candidate.search': 'Buscar candidato TSE',
    'candidate.search.placeholder': 'Nome ou número',
    'candidate.search.empty': 'Nenhum candidato encontrado.',
    'candidate.photo': 'Foto de {name}',

    'detail.loading': 'Carregando detalhes da conta...',
    'detail.error': 'Não foi possível carregar os detalhes da conta.',
    'detail.notFound': 'Conta não encontrada',

    'rename.trigger': 'Renomear conta',
    'rename.title': 'Renomear conta',
    'rename.label': 'Nome da conta',
    'rename.submit': 'Salvar',

    'remove.menu': 'Mais ações da conta',
    'remove.action': 'Parar de monitorar',
    'remove.title': 'Parar de monitorar {name}?',
    'remove.description':
      'A conta sai desta campanha e a coleta dela para. Você pode adicioná-la de novo quando quiser.',
    'remove.confirm': 'Parar de monitorar',

    'noSelection.title': 'Escolha uma conta para ver',
    'noSelection.select': 'Selecionar conta',
    'noSelection.searchPlaceholder': 'Buscar conta monitorada',
    'noSelection.none': 'Nenhuma conta encontrada',

    'kpi.reach.label': 'Alcance relacionado',
    'kpi.reach.caption': 'Publicações relacionadas à campanha, no período',
    'kpi.publications.label': 'Publicações relacionadas',
    'kpi.publications.caption.other': 'de {total} publicadas no período',
    'kpi.publications.caption.one': 'de {total} publicada no período',
    'kpi.relatedShare.label': 'Levou a campanha adiante',
    // `related_share` is a fraction of the account's own output, not a count of amplification
    // events -- `api`'s `AccountKpisOut.related_share` carries no such count (align-fix-accounts-
    // api-reading-routes's own report).
    'kpi.relatedShare.caption': 'da produção da conta no período',
    'kpi.sentiment.label': 'Sentimento médio',
    'kpi.sentiment.caption.other': '{n} comentários analisados',
    'kpi.sentiment.caption.one': '{n} comentário analisado',
    'kpi.empty': 'sem leitura no período',

    'reach.title': 'Alcance ao longo do tempo',
    'reach.subtitle': 'Publicações relacionadas à campanha',
    'reach.chart': 'Alcance diário no período',
    'reach.bestDay': 'Melhor dia',
    'reach.dailyAverage': 'Média diária',
    'reach.postsPerDay': 'Publicações no dia',
    'reach.empty.title': 'Sem leituras de alcance',
    'reach.empty.description': 'Nenhuma publicação teve alcance medido no período.',

    'publications.title': 'O que esta conta publicou',
    'publications.related': 'Relacionadas',
    'publications.all': 'Todas',
    'publications.empty.title': 'Nenhuma publicação',
    'publications.empty.description': 'Esta conta não publicou nada no período.',
    'publications.noMedia': 'Sem mídia',
    'publications.noCaption': 'Sem legenda',
    'publications.kind.carousel': 'carrossel',
    'publications.kind.reel': 'reels',
    'publications.kind.story': 'story',
    'publications.kind.post': 'foto',

    'sentiment.title': 'Comentários nas publicações',
    'sentiment.subtitle': '{read} analisados de {collected} coletados',
    'sentiment.bar': 'Distribuição dos comentários analisados',
    'sentiment.apoiam': 'Apoiam',
    'sentiment.neutros': 'Neutros',
    'sentiment.criticam': 'Criticam',
    'sentiment.empty.title': 'Nenhum comentário coletado',
    'sentiment.empty.description': 'Nenhum comentário foi coletado nas publicações desta conta.',

    'topics.title': 'Assuntos que aparecem',
    'topics.subtitle.other': 'Nas {n} publicações relacionadas',
    'topics.subtitle.one': 'Na {n} publicação relacionada',
    'topics.empty.title': 'Nenhum assunto identificado',
    'topics.empty.description': 'Nenhuma publicação relacionada teve assuntos identificados.',
  },
  {
    title: 'Monitored accounts',
    subtitle: 'Accounts tracked by the campaign and the cost of monitoring them.',
    'nav.overview': 'Overview',
    'nav.account': 'Account',
    'search.placeholder': 'Search monitored account',
    'search.label': 'Search monitored account',
    'filter.platform': 'Platform',
    'filter.allPlatforms': 'All platforms',
    'add.account': 'Add account',
    'hint.profiles.label': 'tracked profiles',
    'hint.profiles.what':
      'Track public profiles: candidates, public figures, media outlets and organisations.',
    'hint.profiles.alignment':
      'Alignment (own, ally, opposition…) is the campaign’s classification of those profiles.',

    'platform.instagram': 'Instagram',
    'platform.tiktok': 'TikTok',

    'band.ally': 'Ally',
    'band.neutral': 'Neutral',
    'band.adversary': 'Adversary',
    'band.campaign': 'Own',
    'alignment.campaign': 'Own',
    'alignment.change': 'Change the alignment',
    'tag.category': '{category}:',
    'card.menu': 'Account actions',
    'card.open': 'View',
    'card.edit': 'Edit tracking',
    'card.rename': 'Rename',
    'card.remove': 'Stop tracking',
    'card.customProfile': 'Custom',
    'card.customised': 'Collection profile customised for this account',
    'card.related': 'Posts related to the campaign in the last 7 days',
    'card.reach': 'Reach of the related posts in the last 7 days',
    'card.lastCollected': 'Last post collected {when}',
    'card.private': 'Private account',
    'card.verified': 'Verified account',
    'card.followers': 'Followers',
    'profile.followers': 'followers',
    'profile.following': 'following',
    'profile.posts': 'posts',
    'status.paused': 'paused',
    'status.paused.hint': 'Monitoring paused: no media is being collected',
    'status.waiting': 'waiting',
    'status.waiting.hint': 'Waiting for the first collection',
    'empty.title': 'No monitored accounts',
    'empty.description': 'No accounts found with the selected filters.',
    'error.title': 'Error loading accounts',
    'error.description': 'Could not load the monitored accounts list.',
    loading: 'Loading accounts...',
    unknownHandle: 'Unidentified account',
    defaultProfile: 'Campaign default',

    'detail.title': 'Account details',
    'detail.back': 'Back to monitored accounts',
    'detail.edit': 'Edit configuration',
    'detail.trackingSummary': 'Tracking summary',
    'detail.mediaEnabled': 'Enabled media',
    'detail.comments': 'Comments',
    'detail.likers': 'Likes',
    'detail.commentsCap': 'Comment cap',
    'detail.audioFanout': 'Audio fan-out',
    'detail.audioPageLimit': 'Audio page limit',
    'detail.enabled': 'Active',
    'detail.disabled': 'Disabled',

    'analysisScope.label': 'Analysis scope',
    'analysisScope.hint':
      'Which of this account’s posts receive metrics, comments, likes and comment analysis.',
    'analysisScope.inherit': 'Inherit from alignment ({effective})',
    'analysisScope.all': 'All posts',
    'analysisScope.related': 'Related only',
    'analysisScope.effective.ALL': 'all posts',
    'analysisScope.effective.RELATED': 'related only',

    'candidate.label': 'Responsible candidate',
    'candidate.none': 'None / not applicable',
    'candidate.clear': 'Clear',
    'candidate.fromAlliances': "Campaign's adversaries",
    'candidate.search': 'Search a TSE candidate',
    'candidate.search.placeholder': 'Name or ballot number',
    'candidate.search.empty': 'No candidate found.',
    'candidate.photo': "{name}'s photo",

    'detail.loading': 'Loading account details...',
    'detail.error': 'Could not load account details.',
    'detail.notFound': 'Account not found',

    'rename.trigger': 'Rename account',
    'rename.title': 'Rename account',
    'rename.label': 'Account name',
    'rename.submit': 'Save',

    'remove.menu': 'More account actions',
    'remove.action': 'Stop tracking',
    'remove.title': 'Stop tracking {name}?',
    'remove.description':
      'The account leaves this campaign and its collection stops. You can add it again at any time.',
    'remove.confirm': 'Stop tracking',

    'noSelection.title': 'Choose an account to view',
    'noSelection.select': 'Select account',
    'noSelection.searchPlaceholder': 'Search monitored account',
    'noSelection.none': 'No account found',

    'kpi.reach.label': 'Related reach',
    'kpi.reach.caption': 'Posts related to the campaign, in the period',
    'kpi.publications.label': 'Related publications',
    'kpi.publications.caption.other': 'of {total} published in the period',
    'kpi.publications.caption.one': 'of {total} published in the period',
    'kpi.relatedShare.label': 'Carried the campaign forward',
    'kpi.relatedShare.caption': 'of the account’s own output in the period',
    'kpi.sentiment.label': 'Average sentiment',
    'kpi.sentiment.caption.other': '{n} comments analysed',
    'kpi.sentiment.caption.one': '{n} comment analysed',
    'kpi.empty': 'no reading in the period',

    'reach.title': 'Reach over time',
    'reach.subtitle': 'Posts related to the campaign',
    'reach.chart': 'Daily reach in the period',
    'reach.bestDay': 'Best day',
    'reach.dailyAverage': 'Daily average',
    'reach.postsPerDay': 'Posts per day',
    'reach.empty.title': 'No reach readings',
    'reach.empty.description': 'No post had its reach measured in the period.',

    'publications.title': 'What this account published',
    'publications.related': 'Related',
    'publications.all': 'All',
    'publications.empty.title': 'No publications',
    'publications.empty.description': 'This account published nothing in the period.',
    'publications.noMedia': 'No media',
    'publications.noCaption': 'No caption',
    'publications.kind.carousel': 'carousel',
    'publications.kind.reel': 'reels',
    'publications.kind.story': 'story',
    'publications.kind.post': 'photo',

    'sentiment.title': 'Comments on publications',
    'sentiment.subtitle': '{read} analysed of {collected} collected',
    'sentiment.bar': 'Distribution of the comments analysed',
    'sentiment.apoiam': 'Support',
    'sentiment.neutros': 'Neutral',
    'sentiment.criticam': 'Criticize',
    'sentiment.empty.title': 'No comments collected',
    'sentiment.empty.description': 'No comment was collected on this account’s publications.',

    'topics.title': 'Topics that come up',
    'topics.subtitle.other': 'In the {n} related publications',
    'topics.subtitle.one': 'In the {n} related publication',
    'topics.empty.title': 'No topics identified',
    'topics.empty.description': 'No related publication had a topic identified.',
  },
);

export const am = accountsCatalogue.t;
export const amPlural = accountsCatalogue.plural;
